/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * List of ineligibility reasons for acknowledging disruption changes
 */
export enum FinnairAcknowledgeIneligibilityReason {
  AMADEUS_REASON = 'AMADEUS_REASON',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

